
import log from "plugins/loglevel/index"
import {
  requestIdleCallback,
} from "plugins/request-animation-frame-polyfill"

import WaitObjectByPathPromise from "app/wait_object_by_path_promise"

import {
  isSignedIn,
} from "app/authentication/state"

import PageInstance from "app/page_instance"

import RentalListingSearch_PageVisitCount from "pages/cities/rental_listing_search/data/page_visit_count"
import SaleListingSearch_PageVisitCount from "pages/cities/sale_listing_search/data/page_visit_count"
import ServicedApartments_PageVisitCount from "pages/cities/serviced_apartments/components/page_visit_count"
import CityLevelOverseasPropertiesLandingPage_PageVisitCount from "apps/spacious_website/pages/buildings/city_level_overseas_properties_landing_page/page_visit_count"
import ListerLandingPage_PVTracker from "apps/spacious_website/pages/listers/lister_landing_page/components/page_visit_count_tracker"

import PageVisitCountTrackerPerPageType from "app/page_visit_count_tracker_per_page_type"


interface RemoveTagDataEntry {
  tagName: string
  tagType: "string" | "number" | "boolean" | "list"
}
type AddTagDataEntry = RemoveTagDataEntry & {
  tagValue: string | number | boolean
}

declare global {
  interface Window {
    truepush: {
      push(x: (() => void) | {
        operation: "add-tags"
        data: AddTagDataEntry[]
      } | {
        operation: "remove-tags"
        data: RemoveTagDataEntry[]
      }): void,
    } | any[] | null,
  }
}
const getTruePush = () => {
  return window.truepush || []
}

// Ensure global var exists
window.truepush = getTruePush()


const onLoad = () => {
  requestIdleCallback(() => {
    log.debug("Starting onLoad for truepush")

    getTruePush().push({
      operation:  "add-tags",
      data:       [
        {
          tagName:  "last_visited_domain_name",
          tagType:  "string",
          // From
          // http://stackoverflow.com/questions/11401897/get-the-current-domain-name-with-javascript-not-the-path-etc
          tagValue: window.location.hostname,
        },

        {
          tagName:  "signed_in_to_spacious",
          tagType:  "boolean",
          // Assumed the response is not cached
          // which should be true most of the time
          tagValue: isSignedIn(),
        },


        {
          tagName:  "city_rental_listing_search_page_visit_count",
          tagType:  "number",
          tagValue: RentalListingSearch_PageVisitCount.getValue(),
        },
        {
          tagName:  "city_sale_listing_search_page_visit_count",
          tagType:  "number",
          tagValue: SaleListingSearch_PageVisitCount.getValue(),
        },
        {
          tagName:  "city_serviced_apartments_page_visit_count",
          tagType:  "number",
          tagValue: ServicedApartments_PageVisitCount.getValue(),
        },
        {
          tagName:  "city_overseas_properties_page_visit_count",
          tagType:  "number",
          tagValue: CityLevelOverseasPropertiesLandingPage_PageVisitCount.getValue(),
        },


        {
          tagName:  "byb_landing_page_visit_count",
          tagType:  "number",
          tagValue: ListerLandingPage_PVTracker.getValue(),
        },

        {
          tagName:  "byb_residential_page_visit_count",
          tagType:  "number",
          tagValue: (new PageVisitCountTrackerPerPageType(
            PageInstance.Enum.spacious_business_intro_for_domestic_residential_agencies_page,
          )).getValue(),
        },
        {
          tagName:  "byb_commercial_page_visit_count",
          tagType:  "number",
          tagValue: (new PageVisitCountTrackerPerPageType(
            PageInstance.Enum.spacious_business_intro_for_domestic_commercial_agencies_page,
          )).getValue(),
        },

        {
          tagName:  "byb_developer_page_visit_count",
          tagType:  "number",
          tagValue: (new PageVisitCountTrackerPerPageType(
            PageInstance.Enum.spacious_business_intro_for_domestic_project_developers_page,
          )).getValue(),
        },
        {
          tagName:  "byb_serviced_apartment_page_visit_count",
          tagType:  "number",
          tagValue: (new PageVisitCountTrackerPerPageType(
            PageInstance.Enum.spacious_business_intro_for_serviced_apartment_providers_page,
          )).getValue(),
        },

        {
          tagName:  "byb_serviced_office_page_visit_count",
          tagType:  "number",
          tagValue: (new PageVisitCountTrackerPerPageType(
            PageInstance.Enum.spacious_business_intro_for_serviced_office_providers_page,
          )).getValue(),
        },
        {
          tagName:  "byb_coworking_space_page_visit_count",
          tagType:  "number",
          tagValue: (new PageVisitCountTrackerPerPageType(
            PageInstance.Enum.spacious_business_intro_for_coworking_space_providers_page,
          )).getValue(),
        },

        {
          tagName:  "byb_overseas_page_visit_count",
          tagType:  "number",
          tagValue: (new PageVisitCountTrackerPerPageType(
            PageInstance.Enum.spacious_business_intro_for_overseas_real_estate_properties_providers_page,
          )).getValue(),
        },

        {
          tagName:  "byb_advertiser_page_visit_count",
          tagType:  "number",
          tagValue: (new PageVisitCountTrackerPerPageType(
            PageInstance.Enum.spacious_business_intro_for_advertiser_page,
          )).getValue(),
        },

        {
          tagName:  "byb_landlord_page_visit_count",
          tagType:  "number",
          tagValue: (new PageVisitCountTrackerPerPageType(
            PageInstance.Enum.listings_submission_pricing,
          )).getValue(),
        },

        {
          tagName:  "byb_remarketing_page_visit_count",
          tagType:  "number",
          tagValue: (new PageVisitCountTrackerPerPageType(
            PageInstance.Enum.lister_remarketing_page,
          )).getValue(),
        },
      ],
    })

    // `I18n` might not be defined when this code run
    // Let's assume the worst
    WaitObjectByPathPromise("I18n.locale")
    .then((locale: string) => {
      getTruePush().push({
        operation:  "add-tags",
        data:       [
          {
            tagName:  "last_used_locale",
            tagType:  "string",
            tagValue: locale,
          },
        ],
      })
    })
    .done()

    // Delete unused/incorrectly set tags
    getTruePush().push(
      {
        operation:  "remove-tags",
        data:       [
          {
            // Incorrect spelling
            // Should be `city_overseas_properties_page_visit_count`
            tagName:  "city_overseas_proeprties_page_visit_count",
            tagType:  "number",
          },
        ],
      }
    )

    getTruePush().push(() => {
      import(
        "app/resources/current_authenticated_user/get/index"
      )
      .then(({
        get: get_current_authenticated_user,
        ResultTypeEnums: GetCurrentAuthenticatedUserTypes,
      }) => {
        get_current_authenticated_user()
        .then(({result_type, data}) => {
          switch (result_type) {
            case GetCurrentAuthenticatedUserTypes.SUCCESS: {
              const input_data: AddTagDataEntry[] = []
              Object.entries(data.onesignal_tags).forEach(([key, val]) => {
                if (typeof val === "string") {
                  input_data.push({
                    tagName:  key,
                    tagType:  "string",
                    tagValue: val,
                  })
                  return
                }
                if (typeof val === "number") {
                  input_data.push({
                    tagName:  key,
                    tagType:  "number",
                    tagValue: val,
                  })
                  return
                }
                if (typeof val === "boolean") {
                  input_data.push({
                    tagName:  key,
                    tagType:  "boolean",
                    tagValue: val,
                  })
                  return
                }
              })

              getTruePush().push({
                operation:  "add-tags",
                data:       input_data,
              })

              break
            }
            case GetCurrentAuthenticatedUserTypes.NOT_SIGNED_IN: {
              break
            }
            default: {
              break
            }
          }
        })
        .done()
      })
    })

    log.debug("Ending onLoad for truepush")
  })
}

export {
  onLoad,
}
